import React from 'react';
import type TBreadcrumbs from './types/TBreadcrumbs';
import Box from '../Box/Box';

const Breadcrumbs = ({ children, modifiers, translations = { ariaLabelBreadcrumb: 'breadcrumb' } }: TBreadcrumbs) => {
  return (
    <Box as="nav" name="Breadcrumbs" aria-label={translations.ariaLabelBreadcrumb} modifiers={modifiers}>
      <Box as="ol" name="BreadcrumbsList">
        {children}
      </Box>
    </Box>
  );
};

export default Breadcrumbs;
